import {getCoordinates} from './coordinates'

const getPosition = (positions, position) => {
	if (!positions) return
	const sides = getCoordinates(positions)

	return {
		position,
		...sides,
	}
}

export const getSticky = sticky => getPosition(sticky, 'sticky')
export const getAbsolute = absolute => getPosition(absolute, 'absolute')
export const getFixed = fixed => getPosition(fixed, 'fixed')
